export class SendEmailConstants {
    static EMAIL_SENDER_CONTROL = "emailSender";
    static EMAIL_SENDER_LABEL = "Email sender";
    static COMPONENT_NAME = "send email component";
    static EMAIL_TEMPLATE_LABEL = "Email template";
    static SELECT_PROPERTY_LABEL = "Select property";
    static EMAIL_SUBJECT_LABEL = "Email subject";
    static EMAIL_SUBJECT_CONTROL = "emailSubject";
    static VALIDATION_MESSAGES = {
        emailSender: "Please enter sender's email address.",
        emailSubject: "Please enter subject."
    };
    static EMAIL_TEXT_LABEL = "Email text";
    static EMAIL_TEXT_CONTROL = "emailText";
    static TEMPLATE_ATTACHMENT_LABEL = "Add default template attachment";
    static SEND_EMAIL_LABEL = "Send Email";
    static ATT_MANAGER_CONTROL = "attachmentManager";
    static NO_RECIPIENT_ERR_MSG = "Please select a recipient with a valid email address or complete all required fields from the recipient form including email address.";
    static SEND_EMAIL_ERR_OBJ = "sendEmail";
    static NO_TEMPLATE_ERR_MSG = "Please select a template to download";
    static NO_COMM_MECHANISM_ERR_MSG;
    static noCommunicationTypeErrMsg = "No communication type selected.";
    static noSubjectErrMsg = "Email subject is required";
    static noTemplateErrMsg = "Template is required";
    static noEmailTextErrMsg = "Email text is required";
    static emailTextConst = "email";
    static bothTextCont = "both";
    static emailCommMechConst = "Email";
    static emailCommDirectionConst = "Outgoing";
    static invalidTemplateTypes = "One or more templates are configured with invalid template types. Please contact your system administrator.";
    static adHocComms = "AdHocComms";
    // steps names
    static CURRENT_STEP_NAMES = {
        "SendSection49NoticesStep": "Send section 49 notices",
        "GenCreateNoticeStep": "GenCreateNotice"
    };
    static alertMessages = {
        communicationLogged: "Communication logged",
        sendEmailSuccessful: "Email successfully sent",
    };
    static stringPlaceholders = {
        jobId: "jobId",
        selected: "selected",
        emailField: "emailField",
        consolidatedGroup: "consolidatedGroup",
        outgoing: "Outgoing",
        externalCommunication: "External Communication",
        communicationType: "CommunicationType",
        autoSendDetails: "autoSendDetails",
        commType: "communicationType",
        attachmentType: "attachmentType"
    };
    static ERROR_SENDING_EMAIL = "Error sending email. Please contact your system administrator.";
    static ERROR_LOGGING_EMAIL = "Error logging the external communication. Please contact your system administrator.";
}
